import styled from 'styled-components';

export const PaginationContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 20px;
  justify-content: center;
  background: inherit;
`;
